// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Is-z","giftOrPromoSelector":"Js-z","disabled":"Ks-z","subTitle":"Ls-z","selectShipAddressMessage":"Ms-z","changePayment":"Ns-z"};